import { Parser } from "@siteimprove/alfa-parser";
import { Token } from "../../syntax/index.js";
import { Value } from "../value.js";
const { map } = Parser;
/**
 * {@link https://drafts.csswg.org/css-values/#strings}
 *
 * @public
 */
export class String extends Value {
    static of(value) {
        return new String(value);
    }
    _value;
    constructor(value) {
        super("string", false);
        this._value = value;
    }
    get value() {
        return this._value;
    }
    resolve() {
        return this;
    }
    equals(value) {
        return value instanceof String && value._value === this._value;
    }
    hash(hash) {
        hash.writeString(this._value);
    }
    toJSON() {
        return {
            ...super.toJSON(),
            value: this._value,
        };
    }
    toString() {
        return `"${this._value.replace(/"/g, '\\"')}"`;
    }
}
/**
 * @public
 */
(function (String) {
    function isString(value) {
        return value instanceof String;
    }
    String.isString = isString;
    String.parse = map(Token.parseString(), (string) => String.of(string.value));
})(String || (String = {}));
//# sourceMappingURL=string.js.map